<template>
  <nav class="nav-bar" :class="{ 'nav-bar-wrap-opacity': !hasScrollSome && opacity }" :style="{ height: h + 'px', position: opacity ? 'fixed' : 'sticky' }">
    <nav class="l-wrap">
      <nuxt-link :to="localePath('/')">
        <img src="https://static.loklok.video/img/loklok-white.png?imageMogr2/format/webp" alt="loklok logo" height="32" width="103" />
      </nuxt-link>
      <ul class="nav-ct">
        <li v-for="navigation of navigations" :key="navigation.id" @click="clickBury(navigation.buryName, 'UM_Event_HeadNaviClick')">
          <a v-if="!isClient" class="seo-link" :href="concatSeoUrl(localePath(navigation.url))">
            <!-- TODO待优化 -->
            <h1 v-if="$route.name && $route.name.indexOf && $route.name.indexOf(navigation.routerName) > -1">{{ navigation.customName || $t(`navigator.${navigation.id}`) }}</h1>
            <template v-else>{{ navigation.customName || $t(`navigator.${navigation.id}`) }}</template>
          </a>
          <client-only>
            <nuxt-link :to="localePath(navigation.url)" class="t3">
              <h1 v-if="$route.name && $route.name.indexOf && $route.name.indexOf(navigation.routerName) > -1">{{ navigation.customName || $t(`navigator.${navigation.id}`) }}</h1>
              <template v-else>{{ navigation.customName || $t(`navigator.${navigation.id}`) }}</template>
              <!-- <span v-else :class="['t3', { active: $route.name && $route.name.indexOf && $route.name.indexOf(navigation.routerName) > -1 }]">{{ $t(`navigator.${navigation.id}`) }}</span> -->
            </nuxt-link>
          </client-only>
        </li>
      </ul>
    </nav>
    <div class="r-wrap">
      <!-- 头部操作栏左边需要插入的栏目 -->
      <slot name="l-ct"></slot>
      <client-only>
        <el-select
          class="search-w"
          name="searchInput"
          v-model="searchContent"
          :placeholder="placeHolder"
          popper-class="select-dropdown"
          :popper-append-to-body="false"
          filterable
          remote
          :remote-method="remoteMethod"
          @keyup.native="keyUpEvent"
          @keyup.enter.native="keyEvent"
          @change="handleChange"
          @visible-change="handleVisibleChange"
          @input.native="handleNativeInput"
        >
          <template slot="prefix">
            <i @click="handleClickSearch" class="iconfont icon-ic_home_search"></i>
          </template>
          <el-option-group v-show="!inputValue" label="历史搜索">
            <i class="rm-i-w iconfont icon-ic_common_delete" @click="$store.commit('app/clearHistory')"></i>
            <el-option v-for="item of Object.values(historys).reverse()" :key="item" :label="item" :value="`${item}_3`">
              <span>{{ item }}</span>
            </el-option>
          </el-option-group>
          <el-option-group :label="$t(searchs.label)">
            <el-option v-for="(item, index) of searchs.options" :key="item + index" :label="item" :value="`${item}_2`">
              <span :class="colorRank[index] ? colorRank[index] : 'rank-other'">{{ index + 1 }}</span>
              <span v-html="item"></span>
            </el-option>
          </el-option-group>
        </el-select>
      </client-only>
      <div>
        <nuxt-link :to="localePath('/download_win')" class="btn-wrap btn-download t4">
          <img src="https://img.loklok.video/img/202503192040786.png" alt="" />
          <span>Windows App</span>
        </nuxt-link>
      </div>
      <div @click="clickBury('下载app')">
        <nuxt-link :to="localePath('/download_nd')" class="btn-wrap btn-download t4">
          <img src="https://img.loklok.video/img/windows12.png" alt="" />
          <span>{{ $t('navigator.download') }}</span>
          <!-- <div class="btn-wrap" aria-command-name="button">
            <img src="https://static.loklok.video/img/search.png" alt="search" height="32">
          </div>-->
        </nuxt-link>
      </div>
      <el-dropdown class="switch-lang-btn" trigger="click">
        <!-- <img src="https://static.loklok.video/img/search.png" alt="search" height="32"> -->
        <div class="btn-wrap" aria-command-name="button" @click="clickBury('切换语言')">
          <i class="iconfont icon-language"></i>
          <span class="t4 current-lang-label" style="user-select: none">{{ $i18n.localeProperties.name }}</span>
          <i class="iconfont icon-arrow2_s"></i>
        </div>
        <el-dropdown-menu class="dropdown-menu" slot="dropdown">
          <template v-for="locale of availableLocales">
            <div @click="clickBury(locale.cnName)">
              <nuxt-link :key="locale.code" :to="switchLocalePath(locale.code)">
                <el-dropdown-item :command="locale.code">
                  {{ locale.name }}
                </el-dropdown-item>
              </nuxt-link>
            </div>
          </template>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- 头部操作栏右边需要插入的栏目 -->
      <slot name="r-ct"></slot>
      <el-popover class="avatar" v-if="!userInfo.portrait" popper-class="popover" placement="bottom-start" width="220" trigger="click">
        <div class="login-w">
          <p class="t3">{{ $t('loginModule.loginTip') }}</p>
          <el-button class="btn t3" type="primary" @click="handleLogin">{{ $t('loginModule.loginButton') }}</el-button>
        </div>
        <!-- <el-button slot="reference">click 激活</el-button> -->
        <template>
          <img slot="reference" class="avatar-w" src="https://static.loklok.video/img/avatar-logout.png?imageMogr2/format/webp" alt="loklok app avatar" height="32" width="32" />
        </template>
      </el-popover>
      <el-popover class="avatar" v-else popper-class="popover" placement="bottom-start" width="220" trigger="click">
        <div class="login-w">
          <p class="t3">{{ $t('loginModule.logoutTip') }}</p>
          <el-button class="btn t3" type="primary" @click="handleLogOut">{{ $t('loginModule.logoutButton') }}</el-button>
        </div>
        <!-- <el-button slot="reference">click 激活</el-button> -->
        <template>
          <img slot="reference" class="avatar-w" :src="userInfo.portrait" alt="loklok app avatar" height="32" width="32" />
        </template>
      </el-popover>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import { htmlDecode } from '~/util'

const tab_mock = [
  {
    id: 'home',
    url: '/',
    routerName: 'index',
    buryName: '主页'
  },
  {
    id: 'all',
    url: '/all',
    routerName: 'all',
    buryName: '探索页'
  },
  {
    id: 'news',
    url: '/articles',
    routerName: 'articles',
    buryName: '文章资讯'
  },
  {
    id: 'contact',
    url: '/contact',
    routerName: 'contact',
    buryName: '联系我们'
  },
  {
    id: 'joinUs',
    url: '/joinUs',
    routerName: 'joinUs',
    buryName: '加入我们'
  }
]

export default {
  props: {
    //tab的高度
    h: {
      type: Number,
      default: 60
    },
    //是否滑动透明
    isOpacity: {
      type: Boolean,
      default: false
    },
    // 主页传入 用于seo 分类页详细链接
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    const newFilters = this.$store.getters.filterParams
    return {
      inputValue: '',
      hasScrollSome: false,
      navigations: this.handleFetchNavigations(newFilters),
      searchContent: '',
      options: [],
      colorRank: ['rank-1', 'rank-2', 'rank-3'],
      searchs: {
        label: 'searchPage.popularSearch',
        options: []
      },
      placeHolder: 'squid game',
      searchType: 0
    }
  },
  computed: {
    opacity() {
      return this?.$route?.name?.indexOf('index') > -1 || this.isOpacity
    },
    ...mapGetters(['i18n', 'historys', 'userInfo', 'filterParams']),
    langLabel() {
      let { label } = this.languages.find((item) => item.value == this.lang)
      return label
    },
    availableLocales() {
      return this.$i18n.locales
    },
    isClient() {
      return !!process.client
    }
  },
  watch: {
    filterParams: {
      handler(val) {
        this.navigations = this.handleFetchNavigations(val)
      },
      deep: true
    }
  },
  created() {
    this.fetchHolar()
    let { keyword } = this.$route.query
    if (keyword) this.searchContent = keyword
    if (this.filterParams.length) {
      this.navigations = this.handleFetchNavigations(this.filterParams)
    }
  },
  mounted() {
    this.watchScroll()
  },
  methods: {
    clickBury(btn, buryEventId) {
      this.$LokBury.handleMD(
        {
          buryEventId,
          buryParams: {
            [buryEventId ? 'UM_Key_ButtonID' : 'UM_Key_ButtonName']: btn
          }
        },
        'click'
      )
    },
    handleClickSearch(e) {
      this.handleSearch()
      e.stopPropagation()
    },
    keyUpEvent() {
      this.searchType = 1
    },
    keyEvent() {
      this.searchType = 1
      this.handleSearch()
    },
    fetchHolar() {
      this.$api.queryPlaceHolder().then((data) => {
        this.placeHolder = data.placeHolder
      })
    },
    remoteMethod(query = '') {
      if (!query) {
        return false
      }
      //this.searchs['label'] = this.$t('searchPage.popularSearch')
      this.$api
        .searchLenovo({
          platformType: 'PC',
          searchKeyWord: query,
          size: 30
        })
        .then((data) => {
          let { searchResults } = data
          this.searchs['options'] = searchResults.map((item) => htmlDecode(item))
        })
    },
    handleLogin() {
      this.$showLoginDialogFunction()
      this.clickBury('登录')
    },
    watchScroll() {
      if (!this.opacity) return
      document.addEventListener('scroll', () => {
        if (window.pageYOffset > 500 && this.hasScrollSome === true) return
        if (window.pageYOffset <= 500 && this.hasScrollSome === false) return
        this.hasScrollSome = !this.hasScrollSome
      })
    },
    //handleCommand(command) {
    // this.$router.replace({
    //   path: this.localePath() + command
    // })
    //this.$i18n.setLocale(command)
    //},
    handleVisibleChange(visible) {
      if (visible) {
        this.searchContent = ''
      }
    },
    handleChange(val) {
      // 通过给val拼接后缀的方式区分历史搜索和联想搜索
      const tempArr = val.split('_')
      this.searchType = Number(tempArr[tempArr.length - 1])
      tempArr.pop()
      const tempStr = tempArr.join('_')
      this.searchContent = tempStr
      this.$store.commit('app/addHistory', this.searchContent)
      //window.location.href = `/search?keyword=${val}`
      this.$router.push({
        path: this.localePath('/search'),
        query: {
          keyword: tempStr,
          type: this.searchType
        }
      })
      this.searchType = 0
    },
    handleLogOut() {
      this.$api.logout().then(() => {
        this.$store.commit('user/SET_TOKEN', '')
        this.$router.go(0)
      })
    },
    handleSearch() {
      let searchInputValue = document.getElementsByName('searchInput')[0].value
      this.handleChange(searchInputValue ? `${searchInputValue}_${this.searchType}` : `${this.placeHolder}_${this.searchType}`)
    },
    handleNativeInput(e) {
      this.inputValue = e.target.value
    },
    concatSeoUrl(url) {
      const urlPrefix = process.env.CURRENT_MODE === 'production' ? 'https://www.loklok.top' : 'http://test-pc.loklok.top'
      return (process.client ? '' : urlPrefix) + url
    },
    handleFetchNavigations(newFilter) {
      // console.log('newFilter', newFilter)
      let mock = tab_mock.map((item) => ({
        ...item,
        customName: this.$t(`navigator.${item.id}`)
      }))
      const arr = [...mock]
      const pushArr = newFilter?.map((item) => ({
        id: item.websiteParam,
        url: `/channel/${item.id}/${item.websiteParam}`,
        name: item.name,
        customName: item.name,
        buryName: item.websiteParam
      }))
      pushArr?.length && arr.splice(1, 1, ...pushArr)
      return arr
    }
  }
}
</script>

<style lang="sass" scoped>
@import './element'
.nav-bar-wrap-opacity
  background-image: linear-gradient(180deg, #0F0F0F 0%, rgba(15, 15, 15, 0.00) 100%)
  background-color: rgba(0, 0, 0, 0)!important

.nav-bar
  position: sticky
  background-color: #000000
  left: 0
  right: 0
  top: 0
  z-index: 999
  display: flex
  align-items: center
  justify-content: space-between
  padding: 0 40px
  flex-wrap: nowrap
  .l-wrap
    display: flex
    align-items: center
    height: 100%
    img
      display: block
    .nav-ct
      display: flex
      align-items: center
      li
        display: flex
        height: 32px
        line-height: 32px
        .seo-link
          position: fixed
          left: -10000px
        a
          margin-left: 30px
          color: $mainTextColor
          cursor: pointer
          display: block
          white-space: nowrap
          font-size: 16px
        h1
          font-size: inherit
        .active
          position: relative
          &::after
            content: ' '
            position: absolute
            bottom: 0px
            height: 4px
            width: 24px
            left: 50%
            transform: translateX(-50%)
            background: $mainColor
            border-radius: 36px
  .r-wrap
    display: flex
    .icon-ic_home_search
      z-index: 999999
      cursor: pointer
    >*
      margin-left: 24px
      order: 10
    .avatar-w
      border-radius: 50%
      width: 32px
      height: 32px
    .btn-wrap
      background: #333333
      border-radius: 16px
      padding: 0 10px 0 10px
      height: 32px
      display: flex
      align-items: center
      cursor: pointer
      .iconfont
        color: $mainTextColor
        font-size: 24px
      span
        margin-inline-start: 5px
      img
        width: 24px
        height: 24px
      .icon-download
        font-weight: 300
      >*
        margin-left: 5px
        &:first-child
          margin-left: 0
    .btn-download, .btn-wrap span
      color: $mainTextColor
      white-space: nowrap
.login-w
  display: flex
  flex-direction: column
  p
    line-height: 24px
    color: $mainTextColor
  .btn
    margin-top: 10px
    border-radius: 110px
    width: 180px
    height: 43px
    align-self: center
@media screen and (max-width: 1610px)
  .r-wrap
    .btn-download
      span
        display: none


@media screen and (max-width: 1440px)
  .article-wrap
    width: 100%
    padding: 0 30px
    .left
      width: calc( 100% - 300px - 40px )
      margin-bottom: 20px
  .l-wrap
    max-width: 650px
    overflow-x: scroll
    flex: 1
  .r-wrap

  .search-w
    .rm-i-w
      font-size: 16px
      position: absolute
      right: 12px
      top: 6px
      cursor: pointer
    :deep
      input
        width: 180px
@media screen and (max-width: 1240px)
  .nav-bar
    padding: 0 20px
    .l-wrap
      .nav-ct
        li
          span
            margin-left: 15px
    .r-wrap
      display: flex
      .icon-ic_home_search
        z-index: 999999
        cursor: pointer
      >*
        margin-left: 15px
@media screen and (max-width: 1140px)
  .nav-bar
    padding: 0 20px
    .l-wrap
      max-width: 450px
      .nav-ct
        li
          span
            margin-left: 15px
    .r-wrap
      display: flex
      .icon-ic_home_search
        z-index: 999999
        cursor: pointer
      >*
        margin-left: 15px
      .btn-wrap
        padding: 0 10px
    .current-lang-label, .icon-arrow2_s
      display: none
@media screen and (max-width: 960px)
  .nav-bar
    padding: 0 20px
    .l-wrap
      .nav-ct
        li
          span
            margin-left: 15px
    .r-wrap
      display: flex
      .icon-ic_home_search
        z-index: 999999
        cursor: pointer
      >*
        margin-left: 15px
      .search-w
        :deep
          input
            width: 0
            padding-left: 0
    .current-lang-label, .icon-arrow2_s
      display: none

@media screen and (max-width: 750px)
  .nav-bar
    padding: 0 20px
    .l-wrap
      .nav-ct
        display: none
    .r-wrap
      display: flex
      .icon-ic_home_search
        z-index: 999999
        cursor: pointer
      >*
        margin-left: 15px
      .search-w
        // 没有设计图，临时手机端隐藏搜搜按钮；
        display: none
        :deep
          input
            width: 0
            padding-left: 0
    .current-lang-label, .icon-arrow2_s
      display: none
  .switch-lang-btn
    order: 1
  .avatar
    display: none
</style>
